import { Link } from 'react-router-dom'

function isBirthdayToday(dateOfBirth) {
  if (!dateOfBirth) return false
  const today = new Date()
  const dob = new Date(dateOfBirth)
  return today.getMonth() === dob.getMonth() && today.getDate() === dob.getDate()
}

export default function WelcomeBanner({ supporter }) {
  const initials = supporter?.full_name
    ?.split(' ').map((n) => n[0]).join('').toUpperCase()

  const isBirthday = isBirthdayToday(supporter?.date_of_birth)
  const firstName = supporter?.full_name?.split(' ')[0]

  return (
    <div className={`border px-5 sm:px-8 py-6 sm:py-8 mb-4 lg:mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-6 transition-all ${
      isBirthday
        ? 'bg-gradient-to-br from-green-900 via-green-950 to-black border-green-500/60'
        : 'bg-gradient-to-br from-green-950 to-black border-green-900/40'
    }`}>
      <div className="flex items-center gap-4 sm:gap-5">
        <div className={`w-12 h-12 sm:w-16 sm:h-16 rounded-full overflow-hidden bg-white/10 border-2 flex items-center justify-center shrink-0 ${
          isBirthday ? 'border-green-400/80' : 'border-green-500/40'
        }`}>
          {supporter?.profile_photo ? (
            <img src={supporter.profile_photo} alt="Profile" className="w-full h-full object-cover" />
          ) : (
            <span className="text-white font-black text-lg sm:text-xl">{initials}</span>
          )}
        </div>
        <div>
          <div className="text-xs text-green-400 uppercase tracking-widest font-semibold mb-1 sm:mb-2">
            {isBirthday ? '🎂 Special Day' : supporter?.clubs?.name}
          </div>
          <h1 className="text-xl sm:text-3xl font-black uppercase tracking-tight mb-1 text-white">
            {isBirthday
              ? `Happy Birthday, ${firstName}!`
              : `Welcome back, ${supporter?.full_name?.split(' ').slice(-1)[0]}`
            }
          </h1>
          <p className="text-gray-400 text-xs sm:text-sm">
            {isBirthday
              ? `Wishing you a wonderful birthday from the entire ${supporter?.clubs?.name} family 🎉`
              : `${supporter?.chapters?.name} Chapter · Member since ${new Date(supporter?.joined_at).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}`
            }
          </p>
        </div>
      </div>
      <Link
        to="/membership-card"
        className="bg-green-600 hover:bg-green-700 text-white px-5 sm:px-6 py-2.5 sm:py-3 font-bold uppercase tracking-widest text-xs sm:text-sm transition-colors whitespace-nowrap self-start sm:self-auto"
      >
        View My Card
      </Link>
    </div>
  )
}